import { render } from "./SelectStore.vue?vue&type=template&id=20742063"
import script from "./SelectStore.vue?vue&type=script&lang=js"
export * from "./SelectStore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__